export const ANALYSIS_STEPS: { id: string; label: string }[] = [
  { id: "search", label: "1" },
  { id: "match", label: "2" },
  { id: "fetch", label: "3" },
  { id: "score", label: "4" },
  { id: "menu", label: "5" },
  { id: "promo", label: "6" },
  {
    id: "competitors",
    label: "7",
  },
  { id: "synthesis", label: "8" },
];

export const ROTATING_MICROCOPY: string[] = ["1", "2", "3", "4", "5"];
